import TomSelect from 'tom-select';

export default class MultiSelect {
    constructor(element) {
        const itemAddHandler = function() {
            this.setTextboxValue('');
            this.refreshOptions();
        };
        const noResultsHandler = function(data, escape){
            return '<div class="no-results">Geen resultaten gevonden voor "'+escape(data.input)+'"</div>';
        };

        let defaultOptions = {
            plugins: [
                'no_backspace_delete',
                'clear_button',
            ],
            onItemAdd: itemAddHandler,
            render: {
                no_results: noResultsHandler,
            },
        };
        if (element.hasAttribute('multiple')) {
            defaultOptions = {
                plugins: [
                    'no_backspace_delete',
                    'remove_button',
                    'clear_button',
                ],
                onItemAdd: itemAddHandler,
                render: {
                    no_results: noResultsHandler,
                },
            };
        }

        new TomSelect(element, defaultOptions);
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new MultiSelect(element));
    }
}
